import { ThemeStyle } from '../../utils/const';
import { getCookie } from '../../utils/cookie';
import { shouldReduceCacheTimeForDevEnv } from '../app/utils';
import { StyleContextProps } from './types';

const STYLE_CONTEXT_STORAGE_VERSION = '1';
const defaultLanguage = getCookie('language') || 'en';
export const STYLE_CONTEXT_URL = '/context/stylecontextjson';
export const DEFAULT_THEME = ThemeStyle.Dark;
export const STYLE_CONTEXT_CACHE_TIMEOUT = shouldReduceCacheTimeForDevEnv() ? 60000 : 1800000;
export const STYLE_CONTEXT_PERSIST_TIME_KEY = `styleContext_v_${STYLE_CONTEXT_STORAGE_VERSION}`;
export const STYLE_CONTEXT_PERSIST_KEY = `__STYLE_CONTEXT__v_${STYLE_CONTEXT_STORAGE_VERSION}`;

export const styleContextDefaultState: StyleContextProps = {
	actionColor: '',
	activeLanguageCode: defaultLanguage,
	activeLanguageId: null,
	defaultLanguageCode: defaultLanguage,
	defaultLanguageId: null,
	footerNavigation: [],
	googleMapsApiKey: null,
	languages: [],
	logo: {
		imageUrl: '',
		location: '/',
		favIcon57: '',
	},
	mainColor: '',
	mainColorHover: '',
	theme: DEFAULT_THEME,
	isCaoWijzerLabel: false,
	cmsImagePathUrl: '',
	isPending: true,
	isInitialized: false,
	isPlatformLabel: false,
};
